import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {BillingComponent} from '@app/billing/billing.component';
import {AuthGuard, I18nModule} from '@spartacus/core';
import {AuthModule} from '@app/auth/auth.module';
import {
  GenericConfiguratorErrorModule
} from '@app/product/configurator/error-handling/generic-configurator-error/generic-configurator-error.module';
import {NetNewModule} from '@app/product/configurator/error-handling/net-new/net-new.module';
import {ContactUsButtonModule, LoadingPageModule} from '@dcp/configurator';

@NgModule({
  declarations: [BillingComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: 'billing',
        component: BillingComponent,
        data: {pageLabel: '/billing'},
        canActivate: [AuthGuard],
      },
    ]),
    I18nModule,
    AuthModule,
    GenericConfiguratorErrorModule,
    NetNewModule,
    LoadingPageModule,
    ContactUsButtonModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ]
})
export class BillingModule {
}
